import { render, staticRenderFns } from "./AnnounceForm.vue?vue&type=template&id=7c56bed9&scoped=true&"
import script from "./AnnounceForm.vue?vue&type=script&lang=js&"
export * from "./AnnounceForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceForm.vue?vue&type=style&index=0&id=7c56bed9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c56bed9",
  null
  
)

export default component.exports